import { createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

const CourseSlice = createSlice({
  name: "Course",
  initialState: {
    AllCoursesData: [],
    courseImage: "",
    courseMainImage: "",
    Coursedetails: [],
    CatagoriesData: [],
    CourseReviews: [],
    CourseExpertData: [],
    StudentCourseData: [],
    CourseScheduleData: [],
    CourseWhishListData: [],
    BookedSlot: {},
    courseSlots: [],

    status: STATUSES.IDLE,
  },
  reducers: {
    SetAllCoursesData: (state, action) => {
      state.AllCoursesData = action.payload;
    },
    setcourseImage: (state, action) => {
      state.courseImage = action.payload;
    },

    setcourseMainImage: (state, action) => {
      state.courseMainImage = action.payload;
    },
    SetCourseDetails: (state, action) => {
      state.Coursedetails = action.payload;
    },
    SetCatagoriesData: (state, action) => {
      state.CatagoriesData = action.payload;
    },
    SetCourseReview: (state, action) => {
      state.CourseReviews = action.payload;
    },
    SetCourseExpertData: (state, action) => {
      state.CourseExpertData = action.payload;
    },
    SetCourseScheduleData: (state, action) => {
      state.CourseScheduleData = action.payload;
    },
    CourseWhishListData: (state, action) => {
      state.CourseWhishListData = action.payload;
    },
    SetStudentCourseData: (state, action) => {
      state.StudentCourseData = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    BookedSlot: (state, action) => {
      state.BookedSlot = action.payload;
    },
    setCourseSlots: (state, action) => {
      state.courseSlots = action.payload;
    },
    SetClearCoursesData: (state, action) => {
      state.AllCoursesData = [];
      state.courseImage = "";
      state.courseMainImage = "";
      state.Coursedetails = [];
      state.CatagoriesData = [];
      state.CourseReviews = [];
      state.CourseExpertData = [];
      state.StudentCourseData = [];
      state.CourseScheduleData = [];
      state.CourseWhishListData = [];
      state.BookedSlot = {};
      state.status = STATUSES.IDLE;
    },
  },
});

export default CourseSlice.reducer;
export const {
  setStatus,
  BookedSlot,
  SetAllCoursesData,
  setcourseImage,
  SetCourseDetails,
  setcourseMainImage,
  SetCatagoriesData,
  SetCourseReview,
  SetCourseExpertData,
  SetCourseScheduleData,
  SetStudentCourseData,
  CourseWhishListData,
  SetClearCoursesData,
  setCourseSlots,
} = CourseSlice.actions;
